import { useMutation } from '@tanstack/react-query';

import { type NangoConnectSessionRequest } from '../../contracts';
import { nangoClient } from '../../data/api/nango';

/**
 * Creates a connect session token. Does not refresh the connections list:
 * that refetch would run before sign-in finishes, and the list refresh
 * belongs to sign-in success (`NangoConnectButton`).
 */
export function useMutateNangoConnectSession() {
  return useMutation({
    mutationKey: ['NangoConnectSession'],
    mutationFn: async (body: NangoConnectSessionRequest = {}) => {
      const { data } = await nangoClient.createConnectSession(body);
      return data;
    },
  });
}
